import { render, staticRenderFns } from "./HeaderChildrenItem.vue?vue&type=template&id=7bdb0987&scoped=true&"
import script from "./HeaderChildrenItem.vue?vue&type=script&lang=js&"
export * from "./HeaderChildrenItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderChildrenItem.vue?vue&type=style&index=0&id=7bdb0987&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdb0987",
  null
  
)

export default component.exports